const TYPES = ['deposit', 'withdraw', 'transfer'];

export const journalPreferences = value => ({
  type: TYPES.includes(value?.type) ? value.type : 'deposit',
  currency: /^[A-Z]{3}$/.test(value?.currency || '') ? value.currency : 'EUR',
});

export const freshJournalForm = preferences => ({
  ...journalPreferences(preferences), accountType: 'Cash', accountNo: '', toAccountNo: '', amount: '', remarks: '',
});